import React, {useState, useEffect, useRef} from 'react';

import Select, { components } from 'react-select';

// Select componentreact-select
export default function Search({value=null, search=false, options=[], multi =false, name="", placeholder = "", getChange, menuHeight = 200, isLocation, setStates, statesList}) {

  const createRef = useRef(null);

    const colourStyles = {    
        control: styles => ({ ...styles, minWidth: search ? 'auto' : '250px' , height : search ?  '55px' : name == 'Sort By' && '30px' , backgroundColor: '#Fff', padding: name == 'Sort By' ? '1px' : '3px', borderColor : '#d9d9d9', borderRadius: name == 'Sort By' ? '5px' : '2px',
      }),
      menu: (provided, state) => ({
        ...provided,
        // backgroundColor: (profileBuilding || technical ) ? '#F1F2F5' : '#fff',
        // marginLeft: profileBuilding && 1,
        // border : '0.5px solid #0B5FFF',
      }),
        placeholder: (styles) => ({
          ...styles,
          color: '#6B6C7E',
          fontSize : '16px',
        }),
        multiValue: (styles) => {
          return {
            ...styles,
            backgroundColor:  '#0B5FFF',
            color: 'white',
          };
        },
        multiValueLabel: (styles) => ({
          ...styles,
          color:  'text-white-1',
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: 'black',
            ':hover': {
              backgroundColor: '#0B5FFF',
              color: 'white',
            },
          }),
        indicatorSeparator: () => {}, // removes the "stick"
        dropdownIndicator: defaultStyles => ({
          ...defaultStyles,
            marginRight: '5px'})
   
    };

    // Show icons
    // const DropdownIndicator = props => {
    //   return (
    //     <components.DropdownIndicator {...props}>
    //       {icon ? icon : img &&<span className={`pr-3 ${iconPlacement} flex items-center`}><img className="h-auto w-auto" src="/grey_location.png" alt="Avatar" /></span>}
    //     </components.DropdownIndicator>
    //   );
    // };
    
    const handleInputChange = (data, action) => {
      // If multi select
      if(multi){
        var array = [];
        data.map( (d) => array.push(d));

        // Function to handle onChange
        getChange(array, action);
      }
      else if(isLocation){
        var array = statesList.filter(d => d.country == data.value);
        var arr = array[0].states.map(d => ({value: d, label: d}))
        setStates(arr);
        getChange(data);
      }
      else{
        // setShow(false);
        // Function to handle onChange
        getChange(data);
      }
    }

    return <div className="mb-4 grow">
      {
        // For multi value selection
        multi === true ? 
          <Select
            styles = {colourStyles}
            name = {name}
            value= {value}
            className = {`w-full`}
            closeMenuOnSelect={true}
            isMulti={true}
            placeholder= {placeholder}
            options={options}
            maxMenuHeight ={menuHeight}
            isLocation = {isLocation}
            onChange={handleInputChange}
            // components={{  DropdownIndicator }}

        />
        : 
      // For single value
    <div className="relative flex">
      <Select
        ref={createRef}
        styles = {colourStyles}
        menuPlacement="auto"
        name = {name}
        value= {value}
        className = {`w-full`}
        isMulti = {multi}
        placeholder= {placeholder}
        maxMenuHeight ={menuHeight}
        options={options}
        onChange={handleInputChange}
        // components={{  DropdownIndicator }}
      />
    </div>
      }
  </div>
}